import type {
  BrowserFillReport,
  SessionLogResult,
} from "@/types/candidatePages";
import type { DailyRoleScanResponse } from "@/types/rolesSkilled";
import {
  getDraftSessionLog,
  launchDraftBrowser,
  runDraftAutopilot,
} from "@/api/candidatePages";
import {
  cancelDailyRoleScan,
  getDailyRoleScanStatus,
  startDailyRoleScan,
} from "@/api/rolesSkilled";

export const dailyRolesWorker = {
  start(signal?: AbortSignal): Promise<DailyRoleScanResponse> {
    return startDailyRoleScan(signal);
  },
  read(jobId: string, signal?: AbortSignal): Promise<DailyRoleScanResponse> {
    return getDailyRoleScanStatus(jobId, signal);
  },
  cancel(jobId: string, signal?: AbortSignal): Promise<DailyRoleScanResponse> {
    return cancelDailyRoleScan(jobId, signal);
  },
};

export const draftAutomationWorker = {
  launch(draftId: string, signal?: AbortSignal): Promise<BrowserFillReport> {
    return launchDraftBrowser(draftId, signal);
  },
  run(draftId: string, sessionId: string, signal?: AbortSignal): Promise<BrowserFillReport> {
    return runDraftAutopilot(draftId, sessionId, signal);
  },
  readLogs(sessionId: string, signal?: AbortSignal): Promise<SessionLogResult> {
    return getDraftSessionLog(sessionId, signal);
  },
};
